import { Input } from 'antd';
import type { TextAreaProps } from 'antd/es/input';
import type React from 'react';
import { useRef, useState } from 'react';

const { TextArea } = Input;

const PATextArea: React.FC<TextAreaProps> = (props) => {
  const { onChange, onCompositionStart, onCompositionEnd, value, ...rest } = props;
  const [isComposing, setIsComposing] = useState(false);
  const [draftValue, setDraftValue] = useState<string | undefined>(undefined);
  const composingRef = useRef(false);

  const handleCompositionStart = (e: React.CompositionEvent<HTMLTextAreaElement>) => {
    composingRef.current = true;
    setIsComposing(true);
    // 初始化本地值为当前受控值，避免一开始就被覆盖
    setDraftValue(typeof value === 'undefined' ? e.currentTarget.value : String(value));
    onCompositionStart?.(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (composingRef.current) {
      // 合成期仅更新本地显示，不触发外部受控更新
      setDraftValue(e.target.value);

      return;
    }

    onChange?.(e);
  };

  const handleCompositionEnd = (e: React.CompositionEvent<HTMLTextAreaElement>) => {
    composingRef.current = false;
    setIsComposing(false);
    // 合成完成后，把最终值一次性提交给父层
    const finalValue = e.currentTarget.value;

    setDraftValue(undefined);

    if (onChange) {
      // 构造一个“像” ChangeEvent 的对象来提交最终值
      const fakeEvent = {
        ...e,
        type: 'change',
        target: { ...e.currentTarget, value: finalValue },
        currentTarget: { ...e.currentTarget, value: finalValue },
        nativeEvent: e.nativeEvent
      } as unknown as React.ChangeEvent<HTMLTextAreaElement>;

      onChange(fakeEvent);
    }

    onCompositionEnd?.(e);
  };

  return (
    <TextArea
      {...rest}
      onChange={handleChange}
      onCompositionEnd={handleCompositionEnd}
      onCompositionStart={handleCompositionStart}
      value={isComposing ? draftValue : value}
    />
  );
};

export default PATextArea;
